import $ from "jquery";

var jsonTypeStr = "application/json; charset=utf-8";
var BffHost = process.env.REACT_APP_BACKEND_URL + "api/";

export const getUserInfo = async (userId, azureToken) => {
    return new Promise(async function (resolve, reject) {
        const url = BffHost + "user/" + azureToken.account.localAccountId;

        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done((data) => {
                resolve(data);
            })
            .fail((err) => {
                reject(err);
                console.error("get userInfoByObjectId fail", err);
            });
    });
};

export const getTargetUserInfo = async (userId, azureToken) => {
    return new Promise(async function (resolve, reject) {
        const url = BffHost + "user/" + userId;

        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done((data) => {
                resolve(data);
            })
            .fail((err) => {
                reject(err);
                console.error("get targetUserInfo fail", err);
            });
    });
};

export const getAllUsers = async (azureToken) => {
    return new Promise(async function (resolve, reject) {
        const url = BffHost + "allusers";

        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done((data) => {
                resolve(data);
            })
            .fail((err) => {
                reject(err);
                console.error("getallusers fail", err);
            });
    });
};

export const getTasks = async (userId, workItemId, azureToken) => {
    return new Promise(async function (resolve, reject) {
        let url = BffHost + "tasks/" + userId;
        if (workItemId) {
            url += "/" + workItemId;
        }
        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done((data) => {
                resolve(data);
            })
            .fail((err) => {
                reject(err);
                console.error("get tasks fail", err);
            });
    });
};

export const getPrioritizedTasks = async (targetUserId, azureToken) => {
    return new Promise(async function (resolve, reject) {
        let url = BffHost + "prioritizedtasks/" + targetUserId;
        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done((data) => {
                resolve(data);
            })
            .fail((err) => {
                reject(err);
                console.error("get prioritized tasks fail", err);
            });
    });
};

export const getPublishedTasks = async (targetUserId, azureToken) => {
    return new Promise(async function (resolve, reject) {
        let url = BffHost + "getpublishedtasksbyuserid/" + targetUserId;
        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done((data) => {
                resolve(data);
            })
            .fail((err) => {
                reject(err);
                console.error("get published tasks fail", err);
            });
    });
};

export const getResponsibleArea = async (userId, azureToken) => {
    return new Promise(async function (resolve, reject) {
        let url = BffHost + "responsiblearea/" + userId;
        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 360000, // 360 sec - increase timeout for Odd Are case
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done((data) => {
                resolve(data);
            })
            .fail((err) => {
                reject(err);
                console.error("get responsible area fail", err);
            });
    });
};

export const AddSubIdsToWorkitem = async (workitemId, subIds, userId, azureToken) => {
    return new Promise(async function (resolve, reject) {
        let url = BffHost + "addsubidstoworkitem";
        const data = {
            SubIds: subIds,
            WorkitemId: workitemId,
            AuthorId: userId,
        };
        const json = JSON.stringify(data);
        $.ajax({
            type: "POST",
            url: url,
            data: json,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done((data) => {
                resolve(data);
            })
            .fail((err) => {
                reject(err);
                console.error("AddSubIdsToWorkitem fail", err);
            });
    });
};

export const createWorkitem = async (data, azureToken) => {
    return new Promise(async function (resolve, reject) {
        let url = BffHost + "createworkitem";
        const json = JSON.stringify(data);
        $.ajax({
            type: "POST",
            url: url,
            data: json,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done((data) => {
                resolve(data);
            })
            .fail((err) => {
                reject(err);
                console.error("CreateWorkitem fail", err);
            });
    });
};

export const getTasksByRole = async (userId, role, azureToken) => {
    return new Promise(async function (resolve, reject) {
        let url = BffHost + "tasksbyrole/" + role + "/" + userId;
        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done((data) => {
                resolve(data);
            })
            .fail((err) => {
                reject(err);
                console.error("getTasksByRole  fail", err);
            });
    });
};

export const makeRevision = async (data, azureToken) => {
    return new Promise(async function (resolve, reject) {
        const url = BffHost + "revision";
        const json = JSON.stringify(data);
        $.ajax({
            type: "POST",
            url: url,
            data: json,
            contentType: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("make revision fail", err);
                reject(err);
            });
    });
};

export const contentReviewerStats = async (userId, azureToken) => {
    return new Promise(async function (resolve, reject) {
        let url =
            BffHost +
            "contentreviewer/" +
            userId +
            // Markus
            // "c75f5d40-73c8-4179-94a9-214591580bce" +
            "/stats";

        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done((data) => {
                resolve(data);
            })
            .fail((err) => {
                reject(err);
                console.error("get contentReviewer stats fail", err);
            });
    });
};

export const getIndexFile = async () => {
    return new Promise(async function (resolve, reject) {
        const url = window.location.origin;

        var myHeaders = new Headers();
        myHeaders.append("pragma", "no-cache");
        myHeaders.append("cache-control", "no-cache");

        var myInit = {
            method: "GET",
            headers: myHeaders,
        };

        fetch(url, myInit)
            .then((data) => {
                let res = data.text();
                resolve(res);
            })
            .catch((err) => {
                reject(err);
                console.error("get index file fail", err);
            });
    });
};

export const log = (level, message, method, workItemId, userRole, userId, azureToken) => {
    return new Promise(function (resolve, reject) {
        const url = BffHost + "log";
        const data = {
            Level: level ?? "INFO",
            Message: message ?? "",
            Method: method ?? "",
            WorkItemId: workItemId ?? "",
            UserAgent: getUserAgent() ?? "",
            UserId: userId ?? "",
            UserRole: userRole ?? "",
        };
        const json = JSON.stringify(data);
        $.ajax({
            type: "POST",
            url: url,
            data: json,
            contentType: jsonTypeStr,
            // accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("send log message fail", err);
                reject(err);
            });
    });
};

export const logMetric = (category, subCategory, status, tag, message, workItemId, userRole, userId, azureToken, payload) => {
    return new Promise(function (resolve, reject) {
        const url = BffHost + "logmetric";
        const data = {
            Category: category ?? "",
            SubCategory: subCategory ?? "",
            WorkItemId: workItemId ?? "",
            Tag: tag ?? "",
            Status: status ?? "",
            Message: message ?? "",
            Payload: payload ?? {},
            UserAgent: getUserAgent(),
            Platform: getOS(),
            UserId: userId ?? "",
            UserRole: userRole ?? "",
        };
        const json = JSON.stringify(data);
        $.ajax({
            type: "POST",
            url: url,
            data: json,
            contentType: jsonTypeStr,
            // accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("send metric message fail", err);
                reject(err);
            });
    });
};

export const updateUserInfo = (newUserInfo, azureToken) => {
    return new Promise(function (resolve, reject) {
        const url = BffHost + "updateuserinfo/" + newUserInfo.Id;
        const json = JSON.stringify(newUserInfo);
        $.ajax({
            type: "POST",
            url: url,
            data: json,
            contentType: jsonTypeStr,
            // accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("Update user info failed", err);
                reject(err);
            });
    });
};

export const uploadUserProfile = (userInfo, profilePicture, azureToken) => {
    return new Promise(function (resolve, reject) {
        const url = BffHost + "uploadprofileimage/" + userInfo.Id;
        const formData = new FormData();
        formData.append("profilePicture", profilePicture);
        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            processData: false, // Prevent jQuery from automatically transforming the data into a query string
            contentType: false, // Let the browser set the content type
            // accepts: jsonTypeStr,
            timeout: 60000, // 60 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("Upload user profile picture failed", err);
                reject(err);
            });
    });
};

export const GetUserSensitiveInfo = (userInfo, azureToken) => {
    return new Promise(function (resolve, reject) {
        const url = BffHost + "usersensitiveinfo/" + userInfo.Id;
        $.ajax({
            type: "GET",
            url: url,
            contentType: "application/json",
            // accepts: jsonTypeStr,
            timeout: 30000, // 30 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("Get user sensitive info failed", err);
                reject(err);
            });
    });
};

export const getContracts = (userInfo, azureToken) => {
    return new Promise(function (resolve, reject) {
        const url = BffHost + "contracts/" + userInfo.Id;
        $.ajax({
            type: "GET",
            url: url,
            timeout: 30000, // 30 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("Get contracts failed", err);
                reject(err);
            });
    });
};

export const getUnresolvedValidations = (userInfo, azureToken) => {
    return new Promise(function (resolve, reject) {
        const url = BffHost + "unresolvedvalidations/" + userInfo.Id;
        $.ajax({
            type: "GET",
            url: url,
            timeout: 30000, // 30 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("Get unresolved validations failed", err);
                reject(err);

            });
    });
};

export const getNewsById = (newsId, azureToken) => {
    return new Promise(function (resolve, reject) {
        const url = BffHost + "news/" + newsId;
        $.ajax({
            type: "GET",
            url: url,
            timeout: 30000, // 30 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("Get news by id failed", err);
                reject(err);

            });
    });
};

export const getPublishedNews = (azureToken) => {
    return new Promise(function (resolve, reject) {
        const url = BffHost + "publishednews";
        $.ajax({
            type: "GET",
            url: url,
            timeout: 30000, // 30 sec
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("Get published news failed", err);
                reject(err);

            });
    });
};

const getUserAgent = () => {
    if (window.navigator && window.navigator.userAgent) {
        return window.navigator.userAgent;
    }
    return "unknown user agent";
};

const getOS = () => {
    if (window.navigator) {
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
        const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
        const iosPlatforms = ["iPhone", "iPad", "iPod"];
        let os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = "Mac OS";
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = "iOS";
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = "Windows";
        } else if (/Android/.test(userAgent)) {
            os = "Android";
        } else if (/Linux/.test(platform)) {
            os = "Linux";
        }

        return os || platform;
    }
    return "unknown";
};

export const setWorkItemStatus = (status, workItemId, userId, azureToken) => {
    return new Promise(async function (resolve, reject) {
        const url = BffHost + "setstatusonworkitem";
        const data = {
            Id: workItemId,
            ActorUserId: userId,
            Status: status,
            OmitNotification: false,
        };
        const json = JSON.stringify(data);
        $.ajax({
            type: "POST",
            url: url,
            data: json,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000,
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("setWorkItemStatus failed", err);
                reject(err);

            });
    });
};

export const setReviewStatus = (type, workItemId, userId, azureToken) => {
    return new Promise(async function (resolve, reject) {
        const url = BffHost + "setreviewstatusonworkitem";
        const data = {
            Id: workItemId,
            ActorUserId: userId,
            ReviewStatus: "Approved",
            ReviewTypes: [type],
        };
        const json = JSON.stringify(data);
        $.ajax({
            type: "POST",
            url: url,
            data: json,
            dataType: "json",
            contentType: jsonTypeStr,
            accepts: jsonTypeStr,
            timeout: 60000,
            beforeSend: function (xhr) {
                //Include the bearer token in header
                if (azureToken.accessToken) {
                    xhr.setRequestHeader("Authorization", "Bearer " + azureToken.accessToken);
                }
            },
        })
            .done(function (data) {
                resolve(data);
            })
            .fail(function (err) {
                console.error("setReviewStatus failed", err);
                reject(err);

            });
    });
};
